import React from "react";
import Title from "./typography/Title";
import Section from "./layout/Section";
import { Pattern } from "./Pattern";
import BodyText from "./typography/BodyText";
import { TitleHeading } from "./typography/TitleHeading";
import {useAnimation } from '../hooks/useAnimate';

interface ProcessProps {
  tag: string;
  title: string;
  steps: {
    title: string;
    description: string;
  }[];
  left?: boolean;
  theme?: "white" | "gray";
}

export const Process: React.FunctionComponent<ProcessProps> = ({
  tag,
  title,
  steps,
  left = true,
  theme,
}) => {
  const { id, animate } = useAnimation();

  return (
    <Section theme={theme} className="lg:flex justify-center" id={id}>
      <div
        className={`w-full mb-8 lg:mb-4 lg:w-4/12 ${
          left ? "lg:order-last lg:ml-24 xl:ml-36" : "lg:mr-24 xl:mr-36"
        }`}
      >
        <div {...animate("fade-down")} className="sticky top-12 z-20">
          <TitleHeading theme="gray" tag={tag} title={title} />
        </div>
      </div>
      <ul role="list" className="flex flex-col  md-auto">
        {steps.map((step, index) => (
          <li key={index} className="flex lg:justify-end -m-1">
            <div
              {...animate("fade-left", index*100)}
              className={`flex flex-col items-center ${
                left ? "lg:order-last" : ""
              }`}
            >
              <span className="h-12 w-0.5 bg-gray-200" aria-hidden="true" />
              <span className="relative h-12 w-12 shrink-0 rounded-full flex items-center justify-center m-4 bg-primary ring-8 ring-gray-200 font-extrabold text-white text-2xl">
                0{index}
              </span>
              {index !== steps.length - 1 && (
                <span
                  className="grow lg:h-6 w-0.5 bg-gray-200"
                  aria-hidden="true"
                />
              )}
            </div>
            <div
              {...animate("fade-right", index*100)}
              className={`mx-10 mt-12 flex flex-col justify-center ${
                left ? "lg:text-right" : ""
              } max-w-sm`}
            >
              <Title small type="h4">
                {step.title}
              </Title>
              <BodyText mb={0} justify={false} className="leading-snug">
                {step.description}
              </BodyText>
            </div>
          </li>
        ))}
      </ul>
      <Pattern
        type="square"
        className={`hidden lg:block absolute h-1/2 w-1/3 bottom-0 ${
          left ? "right-0" : "left-0"
        } text-gray-200 z-10`}
      ></Pattern>
    </Section>
  );
};
